<template>
  <div class="salvar-edital">
    <div class="row">
      <div class="col-xs-12">
        <button type="button" class="btn btn-primary btn-voltar" @click="$router.back()">
          <font-awesome-icon :icon="'arrow-left'"/>
          Voltar
        </button>
        <h2 class="page-header">
          {{ montarTitulo() }}
        </h2>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-sm-4 col-md-3">
        <label
          :class="['custom-font', { 'is-danger': errors.has('numero_edital') }]"
          >Nº do Edital</label
        >
        <input
          type="text"
          ref="numero_edital"
          name="numero_edital"
          v-model="model.numero"
          v-validate="'required'"
          :class="[
            'form-control',
            { 'is-danger': errors.has('numero_edital') }
          ]"
        />
        <message
          :name="'numero_edital'"
          :show="errors.has('numero_edital')"
          :erro="errors.first('numero_edital')"
        />
      </div>
      <div class="form-group col-sm-6 col-md-4">
        <label
          :class="[
            'custom-font',
            { 'is-danger': errors.has('numero_processor') }
          ]"
          >Nº do Processo</label
        >
        <input
          type="text"
          ref="numero_processo"
          name="numero_processo"
          v-model="model.processo_numero"
          v-validate="'required'"
          :class="[
            'form-control',
            { 'is-danger': errors.has('numero_processo') }
          ]"
        />
        <message
          :name="'numero_processo'"
          :show="errors.has('numero_processo')"
          :erro="errors.first('numero_processo')"
        />
      </div>
      <div class="form-group col-sm-2">
        <label
          :class="['custom-font', { 'is-danger': errors.has('publicado') }]"
          >Publicado</label
        >
        <div class="custom-select">
          <select
            name="publicado"
            class="form-control select-selected"
            v-model="model.publicado"
          >
            <option value="0">Não</option>
            <option value="1">Sim</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 form-group">
        <button
          class="btn btn-default"
          @click="salvar()"
          :disabled="carregando"
        >
          <font-awesome-icon v-if="carregando" :icon="'spinner'" spin />
          <font-awesome-icon v-else :icon="'save'" />
          Salvar
        </button>
      </div>
    </div>
    <arquivos-edital :edital="model" v-if="model.id" />
    <cargos :edital_id="model.id" :numero="model.numero" v-if="model.id" />
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}

.custom-select {
  border: 1px solid;
  border-radius: 4px;
  border-color: #00615c;
}

.select-selected {
  background-color: #eeeeee;
  color: #00615c;
}

.custom-font.is-danger {
  color: #990000;
}

.btn-voltar {
  margin-top: 20px;
}
</style>

<script>
import Message from './MensagemErro'
import Cargos from './Cargos'
import ArquivosEdital from './ArquivosEdital.vue'
import { request } from '@/request'

export default {
  components: { Message, Cargos, ArquivosEdital },
  data() {
    return {
      carregando: false,
      model: {}
    }
  },
  created() {
    this.model = {
      publicado: 1,
      ...this.$route.params
    }
  },
  methods: {
    handleLoading() {
      this.carregando = !this.carregando
    },
    montarTitulo() {
      return this.model.id
        ? `Alterar edital - ${this.model.numero}`
        : 'Inserir edital'
    },
    salvar() {
      this.handleLoading()
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.handleLoading()
          this.$refs[this.$validator.errors.items[0].field].focus()
          this.$toastr.e(this.$validator.errors.items[0].msg)
          return
        }

        const { id } = this.model
        if (id) {
          request
            .put(`edital/${id}`, this.model)
            .then(this.saveSuccess)
            .catch(this.saveFail)
            .finally(() => this.handleLoading())
        } else {
          request
            .post('edital', this.model)
            .then(this.saveSuccess)
            .catch(this.saveFail)
            .finally(() => this.handleLoading())
        }
      })
    },
    saveSuccess(response) {
      this.model = {
        ...response.data
      }
      this.$toastr.s('Edital salvo com sucesso.')
    },
    saveFail(error) {
      this.$toastr.s(
        'Houve um erro ao salvar o edital, verifique as informações e tente novamente.'
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/concursos/edital/Save.vue